<div fxFlex="100%" fxLayout="column" class="app-component-container">

  <div class="content">
    <app-loader></app-loader>
    <router-outlet></router-outlet>
  </div>
  <app-footer></app-footer>

</div>
